import React from 'react'
import "./SectionOne.css";
function Attendance({data,setIsModalOpen}) {
  return (
          <button
            onClick={() => setIsModalOpen(true)}
            className="relative group flex flex-col gap-2 px-6 py-4 rounded-2xl w-full  backdrop-blur-xl border border-blue-200/50 shadow-lg  transition-all duration-300"
            title="View Attendance Details"
          >
            {/* Gradient overlay for depth */}
            {/* <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-blue-400/5 to-purple-400/5 opacity-0 group-hover:opacity-100 transition-opacity duration-300" /> */}

            {/* Content */}
            <div className="relative z-10 flex items-center justify-between">
              <span className="font-semibold  text-lg">Attendance</span>
              <div className="flex items-center gap-1.5 px-3 py-1 bg-blue-100/60 backdrop-blur-sm rounded-lg border border-blue-200/50">
                <div className="w-2 h-2 bg-blue-400 rounded-full animate-pulse" />
                <span className="text-sm font-semibold text-blue-900">
                  {data?.attendance?.present_count}/
                  {data?.attendance?.total_attendance}
                </span>
              </div>
            </div>

            {/* Progress bar */}
            <div className="relative w-full h-1.5 bg-blue-100/50 rounded-full overflow-hidden">
              <div
                className="h-full bg-gradient-to-r from-blue-300 to-blue-500 rounded-full transition-all duration-500"
                style={{
                  width: `${
                    (data?.attendance?.present_count /
                      data?.attendance?.total_attendance) *
                      100 || 0
                  }%`,
                }}
              />
            </div>

            {/* View More link */}
            <div className="relative flex items-center gap-1.5 text-xs font-medium group-hover:text-blue-700 transition-colors">
              <span>View Details</span>
              <svg
                className="w-3.5 h-3.5 transform group-hover:translate-x-0.5 transition-transform"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </div>
          </button>
  )
}

export default Attendance
